import { createAction } from 'typesafe-actions';

export const toggleWithPhotoAction = createAction('filters/withPhotoChanged')();
